import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["spacing", "children", "isDisabled", "isFocusable", "inputProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useRadio } from "./chunk-5XCGGO7V.mjs";
import { useRadioGroupContext } from "./chunk-QUJ23J4G.mjs";

// src/radio.tsx
import { chakra, forwardRef, layoutPropNames, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";
import { callAll } from "@chakra-ui/shared-utils";

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  var picked = {};
  var omitted = {};
  for (var _i = 0, _Object$entries = Object.entries(object); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (keys.includes(key)) picked[key] = value;else omitted[key] = value;
  }
  return [picked, omitted];
}

// src/radio.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Radio = forwardRef(function (props, ref) {
  var _a;
  var group = useRadioGroupContext();
  var onChangeProp = props.onChange,
    valueProp = props.value;
  var styles = useMultiStyleConfig("Radio", _objectSpread(_objectSpread({}, group), props));
  var ownProps = omitThemingProps(props);
  var _ownProps$spacing = ownProps.spacing,
    spacing = _ownProps$spacing === void 0 ? "0.5rem" : _ownProps$spacing,
    children = ownProps.children,
    _ownProps$isDisabled = ownProps.isDisabled,
    isDisabled = _ownProps$isDisabled === void 0 ? group == null ? void 0 : group.isDisabled : _ownProps$isDisabled,
    _ownProps$isFocusable = ownProps.isFocusable,
    isFocusable = _ownProps$isFocusable === void 0 ? group == null ? void 0 : group.isFocusable : _ownProps$isFocusable,
    htmlInputProps = ownProps.inputProps,
    rest = _objectWithoutProperties(ownProps, _excluded);
  var isChecked = props.isChecked;
  if ((group == null ? void 0 : group.value) != null && valueProp != null) {
    isChecked = group.value === valueProp;
  }
  var onChange = onChangeProp;
  if ((group == null ? void 0 : group.onChange) && valueProp != null) {
    onChange = callAll(group.onChange, onChangeProp);
  }
  var name = (_a = props == null ? void 0 : props.name) != null ? _a : group == null ? void 0 : group.name;
  var _useRadio = useRadio(_objectSpread(_objectSpread({}, rest), {}, {
      isChecked: isChecked,
      isFocusable: isFocusable,
      isDisabled: isDisabled,
      onChange: onChange,
      name: name
    })),
    getInputProps = _useRadio.getInputProps,
    getCheckboxProps = _useRadio.getCheckboxProps,
    getLabelProps = _useRadio.getLabelProps,
    getRootProps = _useRadio.getRootProps,
    htmlProps = _useRadio.htmlProps;
  var _split = split(htmlProps, layoutPropNames),
    _split2 = _slicedToArray(_split, 2),
    layoutProps = _split2[0],
    otherProps = _split2[1];
  var checkboxProps = getCheckboxProps(otherProps);
  var inputProps = getInputProps(htmlInputProps, ref);
  var labelProps = getLabelProps();
  var rootProps = Object.assign({}, layoutProps, getRootProps());
  var rootStyles = _objectSpread({
    display: "inline-flex",
    alignItems: "center",
    verticalAlign: "top",
    cursor: "pointer",
    position: "relative"
  }, styles.container);
  var checkboxStyles = _objectSpread({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  }, styles.control);
  var labelStyles = _objectSpread({
    userSelect: "none",
    marginStart: spacing
  }, styles.label);
  return /* @__PURE__ */jsxs(chakra.label, _objectSpread(_objectSpread({
    className: "chakra-radio"
  }, rootProps), {}, {
    __css: rootStyles,
    children: [/* @__PURE__ */jsx("input", _objectSpread({
      className: "chakra-radio__input"
    }, inputProps)), /* @__PURE__ */jsx(chakra.span, _objectSpread(_objectSpread({
      className: "chakra-radio__control"
    }, checkboxProps), {}, {
      __css: checkboxStyles
    })), children && /* @__PURE__ */jsx(chakra.span, _objectSpread(_objectSpread({
      className: "chakra-radio__label"
    }, labelProps), {}, {
      __css: labelStyles,
      children: children
    }))]
  }));
});
Radio.displayName = "Radio";
export { Radio };